module.exports = __webpack_public_path__ + "img/ksero.340bbf39.png";